import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { NgxMatTimepickerComponent } from "ngx-mat-timepicker/lib/components/ngx-mat-timepicker/ngx-mat-timepicker.component";

@Component({
    selector: 'cr-time-picker',
    templateUrl: './timePicker.html',
    styleUrls: ['./timePicker.scss'],
    encapsulation: ViewEncapsulation.None
  })
export class TimePickerComponent {
    private timezoneoffset = (new Date()).getTimezoneOffset() * 60000;
    @Input() disabled : boolean = false; //2022-03-12 (aaangeles)
    @Input() readonly : boolean = true; //2022-03-12 (aaangeles)
    @Input() ngClass : string = '';
    @Input() value : string = '';
    @Input() label: string = ''; // 2022-01-04 (aaangeles)
    @Input() defaultTime : boolean;
    @Input() required: boolean = false;
    @Input() borrar: boolean = false;
    @Output() GetTime = new EventEmitter();
    // public timePicker : NgxMatTimepickerComponent;
    @ViewChild('timePicker') timePicker : NgxMatTimepickerComponent; // 2022-03-19

    public onTimeChange(event){
        this.GetTime.emit(event)
    }

   /**
    * name
    */
   public abrir() {
    if( this.disabled) return; // 2022-03-12 (aaangeles)
    if (this.defaultTime && !this.value) {
      this.value = new Date(Date.now() - this.timezoneoffset).toISOString().slice(0,19).slice(0, -1).split('T')[1].substring(0, 5);
      this.timePicker.defaultTime = this.value;
    }
    if(this.timePicker) this.timePicker.open();
   }

   GetDefaultTime() {
    if (this.defaultTime && !this.value) {
      return new Date(Date.now() - this.timezoneoffset).toISOString().slice(0,19).slice(0, -1).split('T')[1].substring(0, 5);
    }
    else {
      return this.value;
    }
   }
   public limpiar() {
    this.timePicker.defaultTime = null;
    this.value = null;
    this.GetTime.emit(null);
   }

   public CheckValue(val, control) {
      console.log(val);
      console.log(control);
   }
}